/*
  Boton "ir al producto" del bloque scroll_to_product de sections/image-with-text.liquid.

  Se invoca desde un onclick en linea:
    onclick="scrollToProductExact('{{ block.settings.target_product_id }}', {{ block.settings.scroll_offset }})"

  Por eso la funcion tiene que colgar de window: un onclick en linea solo
  resuelve nombres globales. Sin ella, cada clic lanzaba
  "ReferenceError: scrollToProductExact is not defined".

  target_product_id es un ajuste de tipo `product`, o sea un ID numerico, y
  <product-info> ya expone data-product-id. Asi que el destino se localiza con
  ese atributo, sin anadir marcadores nuevos al tema.
*/
(function () {
  window.scrollToProductExact = function (productId, offset) {
    var target = null;

    if (productId) {
      target = document.querySelector('[data-product-id="' + productId + '"]');
    }

    // Si el ajuste apunta a otro producto o esta vacio, se usa el bloque de
    // producto de la propia pagina, que es lo que el ajuste pide ("Poner el
    // producto de esta pagina").
    if (!target) target = document.querySelector('product-info');
    if (!target) return;

    var gap = parseInt(offset, 10);
    if (isNaN(gap)) gap = 0;

    var top = target.getBoundingClientRect().top + window.pageYOffset - gap;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });
  };
})();
